"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowDateEdit_1 = require("../../../../shared/components/editors/CardRowDateEdit");
var CardRowCheckBoxEditor_1 = require("../../../../shared/components/editors/CardRowCheckBoxEditor");
var DlgSetPromoCodeExpirationParam = /** @class */ (function (_super) {
    __extends(DlgSetPromoCodeExpirationParam, _super);
    function DlgSetPromoCodeExpirationParam(props) {
        return _super.call(this, props) || this;
    }
    DlgSetPromoCodeExpirationParam.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                year: data.year,
                month: data.month,
                day: data.day,
                is_expire: data.is_expire
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            dialogTitle: this.props.controller.DATA.title,
            year: this.props.controller.DATA.year,
            month: this.props.controller.DATA.month,
            day: this.props.controller.DATA.day,
            is_expire: this.props.controller.DATA.is_expire
        });
        this.doReSetRules();
    };
    DlgSetPromoCodeExpirationParam.prototype.doReSetRules = function () {
        //this.setState({
        //    amount_rules: { isError: false },
        //})
    };
    DlgSetPromoCodeExpirationParam.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSetPromoCodeExpirationParam.prototype.isDataValid = function () {
        this.doReSetRules();
        //if (this.state.amount < 0) {
        //    this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] слишком мало!" } })
        //    return false;
        //}
        //if (isNaN(this.state.amount)) {
        //    this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] некорректно!" } })
        //    return false;
        //}
        return true;
    };
    DlgSetPromoCodeExpirationParam.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.is_expire, this.state.year, this.state.month, this.state.day);
            }
        }
    };
    DlgSetPromoCodeExpirationParam.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSetPromoCodeExpirationParam.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 610, width: "610px" }, width: 610 },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" } },
                React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Срок действия(включительно)", placeholder: "Выберите срок действия(включительно)" }, value: { day: this.state.day, month: this.state.month, year: this.state.year }, onValueChanged: function (Year, Month, Day) {
                        _this.setState({
                            day: Day,
                            month: Month,
                            year: Year
                        });
                    }, disabled: !this.state.is_expire }),
                React.createElement(CardRowCheckBoxEditor_1.default, { title: "Промокод имеет срок действия", value: this.state.is_expire, onChecked: function (checked) { _this.setState({ is_expire: checked }); } }))));
    };
    return DlgSetPromoCodeExpirationParam;
}(React.Component));
exports.default = DlgSetPromoCodeExpirationParam;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSetPromoCodeExpirationParam.tsx
// module id = 2498
// module chunks = 0